import { createSlice } from "@reduxjs/toolkit";
import * as OrderApi from "../api/order";

const orders = createSlice({
  name: "orders",
  initialState: {
    loading: false,
    error: null,
    list: [],
    summary: null,
  },
  reducers: {
    setLoading: (state) => {
      state.error = null;
      state.loading = true;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    getListSuccess: (state, action) => {
      state.list = action.payload.docs;
      state.summary = action.payload.summary;
      state.loading = false;
    },
  },
});

export const getListOrder = (params) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const res = await OrderApi.getListOrder(params);
    dispatch(getListSuccess(res));
  } catch (error) {
    dispatch(setError(error));
  }
};

const { reducer, actions } = orders;
export const { setLoading, setError, getListSuccess } = actions;
export default reducer;
